import * as PaymentAPI from 'api/payment.api.js'

module.exports = {
  fetchProductInfo: (coachOrgId) => ({
    type: 'FETCH_PRODUCT_INFO',
    coachOrgId
  }),

  fetchOnboardingOptions: (coachOrgId) => ({
    type: 'FETCH_ONBOARDING_OPTIONS',
    coachOrgId
  }),

  initLegacyStripeCheckout: (data) => async (dispatch) => {
    const response = await PaymentAPI.InitLegacyStripeCheckout(data);
    return response;
  },

  stripePassCredentials: (authCode, scope) => ({
    type: 'STRIPE_PASS_CREDENTIALS',
    authCode, scope
  }),

  initUpdateCard: (uid, stripeData) => ({
    type: 'INIT_UPDATE_CARD',
    uid,
    stripeData
  }),

  listenUpdateCardResponse: (uid) => (dispatch) => {
    const path = `requests/onUpdateCard/${uid}/response`;
    PaymentAPI.ListenUserUpdateCardResponse(path, dispatch)
  },

  initStripeCheckout: (data) => async (dispatch) => {
    const response = await PaymentAPI.InitStripeCheckout(data);
    return response;
  },

  initRedeemVoucher: (data) => async (dispatch) => {
    const response = await PaymentAPI.InitRedeemVoucher(data);
    return response
  },
};


// WEBPACK FOOTER //
// ./src/actions/paymentActions.js